import React, { useRef, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Skeleton, styled } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import moment from 'moment';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './NextRescueSliderStyles.css';
import { Colors } from '../../../../assets/theme/Colors';
import RecentRescue from '../../../../components/RescueNotification/RecentRescue';
import UpcomingRescue from '../../../../components/RescueNotification/UpcomingRescue';
import { getRescueClaimer } from '../../../../helpers/RescuesHelper';

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  backgroundColor: 'transparent',
}));

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  ...theme.typography.h6,
  borderRadius: theme.spacing(2),
  backgroundColor: Colors.rescues.today.color,
  padding: theme.spacing(2),
  fontWeight: 500,
  textDecoration: 'none',
  color: '#fff',
  minHeight: 60,
  maxHeight: 60,
  '&.Mui-expanded': {
    minHeight: 60,
    maxHeight: 60,
  },
}));

const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: 0,
  paddingTop: theme.spacing(2),
  display: 'block',
}));

const NextRescues = ({
  renderNextRescueSummary,
  nextRescues = [],
  id = '',
  isLoading = false,
  isReceiverView = false,
  isDonorView = false,
}) => {
  const [currentRescueSlide, setCurrentRescueSlide] = useState(0);
  const rescueSliderRef = useRef();
  const nextRescueRef = useRef();

  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    beforeChange: (current, next) => setTimeout(() => setCurrentRescueSlide(next), 200),
  };

  if (isLoading) {
    return (
      <StyledAccordion defaultExpanded square elevation={0} ref={nextRescueRef} data-introid={id}>
        <StyledAccordionSummary>
          <Skeleton width="100%" />
        </StyledAccordionSummary>
      </StyledAccordion>
    );
  }

  return (
    <StyledAccordion defaultExpanded square elevation={0} ref={nextRescueRef} data-introid={id}>
      <StyledAccordionSummary expandIcon={nextRescues.length ? <ExpandMore sx={{ color: '#fff' }} /> : null}>
        {renderNextRescueSummary()}
      </StyledAccordionSummary>
      {!!nextRescues.length && (
        <StyledAccordionDetails>
          <Box
            id="next-rescue-slider"
            boxShadow={25}
            sx={{ width: '100%', borderRadius: '8px 16px 16px 8px', backgroundColor: '#fff', overflow: 'hidden' }}
          >
            <Slider adaptiveHeight className="next-rescue-slider" {...settings} ref={rescueSliderRef}>
              {nextRescues.map((rescue) => {
                const claimer = getRescueClaimer(rescue);
                if (rescue.date === moment().format('YYYYMMDD')) {
                  return (
                    <Box key={rescue.id}>
                      <RecentRescue
                        rescue={rescue}
                        noShadow
                        isRescueSlider
                        currentSlide={currentRescueSlide}
                        maxSlides={nextRescues.length}
                        handleSliderNext={() => rescueSliderRef?.current?.slickNext()}
                        handleSliderPrev={() => rescueSliderRef?.current?.slickPrev()}
                        isReceiverView={isReceiverView}
                        isDonorView={isDonorView}
                        claimer={claimer}
                        rescueSliderRef={rescueSliderRef}
                      />
                    </Box>
                  );
                }

                return (
                  <Box key={rescue.id} sx={{ height: '100%' }}>
                    <UpcomingRescue
                      rescue={rescue}
                      noShadow
                      isRescueSlider
                      currentSlide={currentRescueSlide}
                      maxSlides={nextRescues.length}
                      handleSliderNext={() => rescueSliderRef?.current?.slickNext()}
                      handleSliderPrev={() => rescueSliderRef?.current?.slickPrev()}
                      isReceiverView={isReceiverView}
                      isDonorView={isDonorView}
                      claimer={claimer}
                      rescueSliderRef={rescueSliderRef}
                    />
                  </Box>
                );
              })}
            </Slider>
          </Box>
        </StyledAccordionDetails>
      )}
    </StyledAccordion>
  );
};

export default NextRescues;
